import React, { useEffect, createElement } from 'react';
import { AfterSchoolHeroInfo } from './after-school/AfterSchoolHeroInfo';
import { AfterSchoolHeroForm } from './after-school/AfterSchoolHeroForm';
import { AfterSchoolBenefits } from './after-school/AfterSchoolBenefits';
import { AfterSchoolWhatYouLearn } from './after-school/AfterSchoolWhatYouLearn';
import { AfterSchoolReviews } from './after-school/AfterSchoolReviews';
import { AfterSchoolScheduleLocation } from './after-school/AfterSchoolScheduleLocation';
import { AfterSchoolFAQHeader } from './after-school/AfterSchoolFAQHeader';
import { AfterSchoolFAQQuestions } from './after-school/AfterSchoolFAQQuestions';
import { AfterSchoolFAQActions } from './after-school/AfterSchoolFAQActions';
import { AfterSchoolFinalCTA } from './after-school/AfterSchoolFinalCTA';
export function AfterSchool() {
  useEffect(() => {
    document.title = 'After School Activities Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Looking for after school activities in Farmington Hills? Storm Taekwondo offers kids martial arts classes that build confidence, focus, and discipline.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Looking for after school activities in Farmington Hills? Storm Taekwondo offers kids martial arts classes that build confidence, focus, and discipline.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-690">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-691">
        <div className="absolute inset-0 opacity-20" data-id="element-692">
          <img src="https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=1200&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-693" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-694" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-695">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-696">
            <AfterSchoolHeroInfo data-id="element-697" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-698">
              <AfterSchoolHeroForm data-id="element-699" />
            </div>
          </div>
        </div>
      </section>
      <AfterSchoolBenefits data-id="element-700" />
      <AfterSchoolWhatYouLearn data-id="element-701" />
      <AfterSchoolReviews data-id="element-702" />
      <AfterSchoolScheduleLocation data-id="element-703" />
      <section className="py-24 bg-off-white" data-id="element-704">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-705">
          <AfterSchoolFAQHeader data-id="element-706" />
          <AfterSchoolFAQQuestions data-id="element-707" />
          <AfterSchoolFAQActions data-id="element-708" />
        </div>
      </section>
      <AfterSchoolFinalCTA data-id="element-709" />
    </div>;
}